/*
 Copyright (c), CKSource Holding sp. z o.o. All rights reserved.
 */

import Message, { IMessage } from './../../message';
import { IDescriptorBody } from '../../descriptor';

export interface IIsEditorBundleUploadedMessage extends IMessage {
	bundleVersion: string;
}

export default class IsEditorBundleUploadedMessage extends Message {
	public static readonly TYPE: string = '131';

	public static readonly READABLE_TYPE_NAME: string = 'isEditorBundleUploaded';

	public static readonly DESCRIPTOR_NAME: string = 'IsEditorBundleUploadedMessage';

	public static readonly DESCRIPTOR: IDescriptorBody = {
		fields: {
			bundleVersion: {
				type: 'string',
				id: 1
			}
		}
	};

	public constructor( public readonly bundleVersion: string ) {
		super();
	}

	public toJSON(): IIsEditorBundleUploadedMessage {
		return {
			bundleVersion: this.bundleVersion
		};
	}

	public static fromJSON( object: IIsEditorBundleUploadedMessage ): IsEditorBundleUploadedMessage {
		return new IsEditorBundleUploadedMessage( object.bundleVersion );
	}
}
